module.exports = __webpack_public_path__ + "static/media/vi_china.96d9b338.png";